import React from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary, installGlobalErrorOverlay } from "@orcmatic/ui";
import { App } from "./App";
import "@orcmatic/ui/styles";

installGlobalErrorOverlay();

const root = document.getElementById("root");
if (!root) throw new Error("No #root element found");
createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
